import { render, staticRenderFns } from "./SlideGroupComponent.vue?vue&type=template&id=c39ca9ce"
import script from "./SlideGroupComponent.vue?vue&type=script&lang=js"
export * from "./SlideGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports